export default __webpack_public_path__ + "static/media/US.9a4d7abc.png";